import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

// -------- Email Log (admin) --------
export function EmailLogAdmin() {
  const [data, setData] = useState({ logs: [], resend_configured: false, notification_email: "" });
  const load = () => api.get("/admin/email-log").then(r => setData(r.data));
  useEffect(() => { load(); }, []);
  const sendTest = async () => {
    const r = await api.post("/admin/email-log/test");
    if (r.data.sent) toast.success("Test email sent");
    else toast.error(r.data.error || "Test logged only (Resend not configured)");
    load();
  };
  const resend = async (id) => {
    const r = await api.post(`/admin/email-log/${id}/resend`);
    if (r.data.sent) toast.success("Re-sent");
    else toast.error(r.data.error || "Re-send failed");
    load();
  };
  return (
    <div>
      <h1 className="font-serif text-4xl mb-1">Order Notifications</h1>
      <div className="overline text-white/40 mb-4">
        Notifications routed to <span className="text-white">{data.notification_email}</span>
        {data.resend_configured
          ? <span className="ml-3 text-green-400/80">· Resend connected</span>
          : <span className="ml-3 text-yellow-500/80">· Resend key not set — emails are logged only</span>}
      </div>
      <button onClick={sendTest} data-testid="email-test-btn"
        className="mb-6 px-4 py-2 text-xs uppercase tracking-widest border border-white/15 hover:border-white/40">
        Send Test Email
      </button>
      <div className="surface p-0 overflow-x-auto" data-testid="email-log-table">
        <table className="w-full text-sm font-mono-brand">
          <thead className="text-white/50 text-xs uppercase">
            <tr>
              <th className="text-left p-3">When</th>
              <th className="text-left p-3">Kind</th>
              <th className="text-left p-3">To</th>
              <th className="text-left p-3">Subject</th>
              <th className="text-left p-3">Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.logs.length === 0 && <tr><td colSpan={6} className="p-6 text-white/40 text-center">No notifications yet.</td></tr>}
            {data.logs.map(l => (
              <tr key={l.id} className="border-t border-white/10" data-testid={`email-log-row-${l.id}`}>
                <td className="p-3 text-white/70">{new Date(l.created_at).toLocaleString()}</td>
                <td className="p-3">{l.kind}</td>
                <td className="p-3 text-white/70">{l.to}</td>
                <td className="p-3">{l.subject}</td>
                <td className="p-3">
                  {l.sent
                    ? <span className="text-green-400">sent · {l.provider}</span>
                    : <span className="text-yellow-500">logged</span>}
                </td>
                <td className="p-3 text-right">
                  <button onClick={() => resend(l.id)} className="text-xs text-white/60 hover:text-white" data-testid={`email-log-resend-${l.id}`}>
                    Resend
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}


